import React, { useEffect, useReducer } from 'react';
import styles from './JackpotCasino.scss';
import cn from 'classnames';

// MANAGERS
import { TJackpotCasinoUsersHitLevelItem } from '@GFTypes/index';
import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import timeFormat from '@Tools/TimeFormat';

const JackpotCasinoHitGroup: React.FC<{
    hitsData: Array<TJackpotCasinoUsersHitLevelItem>;
}> = ({ hitsData }) => {
    useEffect(() => {});

    return (
        <>
            {hitsData.length > 0 && (
                <div>
                    <div className={styles.jackpot_casino_states_header}>
                        Users Hits: <br />
                        Update time: {timeFormat(hitsData[0].hitTimestamp).time}
                    </div>
                    <div>
                        <>
                            {hitsData.map((e: TJackpotCasinoUsersHitLevelItem, i: number) => {
                                return (
                                    <div className={styles.jackpot_casino_states_level} key={i}>
                                        {e.levelName}: {CurrencyUtils.formatRawCurrencyValue(e.hitValue)}
                                    </div>
                                );
                            })}
                        </>
                    </div>
                </div>
            )}
        </>
    );
};

export default JackpotCasinoHitGroup;
